<template>
    <div id="ContainerNotifications">
        <div class="row">
            <div class="col-12">
                <h4 class="page-title text-truncate">
                    {{ $t('notificationsList.Title') }}
                </h4>
                <div class="row">
                    <div class="col-sm-12 col-md-3" v-if="hasPermissionAdd()">
                        <MdButton
                            v-bind:Label="$t('Shared.Add')"
                            v-bind:ClassProp="'btn btn-primary my-3 btn-block btn-login'"
                            v-bind:IconClass="'ti-plus pr-1'"
                            v-on:click="AddNotification"
                            v-bind:Name="'btn_add_notification'"
                        >
                        </MdButton>
                    </div>
                    <div
                        v-bind:class="
                            hasPermissionAdd()
                                ? 'col-sm-12 col-md-9 mb-4'
                                : 'col-sm-12 col-md-12 mb-4'
                        "
                    >
                        <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                            <div class="input-group" dir="ltr">
                                <input
                                    type="text"
                                    class="form-control"
                                    :dir="dirInput"
                                    v-model="parameter.SearchCriteria"
                                    @keyup.enter="SearchNotification"
                                />
                                <div class="input-group-append">
                                    <div class="input-group-append">
                                        <MdButton
                                            v-bind:Name="'btnsearchinput'"
                                            v-bind:VariantProp="'btn btn-sm search-attached'"
                                            v-bind:IconClass="'mdi mdi-magnify'"
                                            v-on:click="SearchNotification"
                                        >
                                        </MdButton>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 mt-2">
                <MdTitle
                    v-bind:Text="$t('Shared.SearchResult')"
                    v-bind:isSubtitle="true"
                    v-bind:Name="'T_TitleSearch'"
                />
                <div class="row">
                    <div class="col-md-12">
                        <MdTable
                            v-bind:fields="fields"
                            v-bind:items="items"
                            v-bind:totalRows="totalRows"
                            v-bind:isReadOnly="isReadOnly"
                            v-bind:showMessageIsEmpty="showMessageIsEmpty"
                            v-bind:currentPage="currentPage"
                            v-bind:perPage="perPage"
                            v-bind:pageOptions="pageOptions"
                            :editIconEvent="editNotification"
                            v-bind:VisibleEditIcon="hasPermissionEdit()"
                            :deleteIconEvent="removeNotification"
                            v-bind:VisibleDeleteIcon="hasPermissionDelete()"
                            :onRowSelected="onRowSelected"
                            :onFiltered="onFiltered"
                            :pageChanged="pageChanged"
                            :perPageFunction="perPageFunction"
                        >
                        </MdTable>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NotificationsService from '@/services/notifications.service';
import ShowMessage from '@/components/messages/ShowMessage.js';
import DBFunctions from '@/common/DBFunctions.js';
import Permission from '@/common/Permission';

export default {
    mixins: [ShowMessage, DBFunctions, Permission],
    name: 'NOTIFICATIONSLIST',
    data() {
        return {
            OptionsRightMenu: {
                visible: false,
                ItemsList: [],
                btnvisible: false,
                itemdisabled: false,
                PatientCode: '',
                Mode: this.edit_mode,
                favButtonAtion: false
            },
            patient: {},
            //permission:[],
            //Menu : this.$store.state.leftMenu,
            code: '',
            showMessageIsEmpty: false,
            Loading: true,
            PatientTitle: {
                programName: '',
                fullName: '',
                admitDate: '',
                dischargeDate: '',
                dob: ''
            },
            Mode: '',
            parameter: {
                SearchCriteria: '',
                PageNumber: 0,
                PageSize: 0,
                PatientCode: ''
            },
            fields: [
                { key: 'recId', sortable: false, label: this.$t('Shared.Code'), class: 'hidden' },
                { key: 'notificationType', sortable: true, label: this.$t('notificationsList.Listing.eType'), class: 'text-rigth' },
                { key: 'hostName', sortable: true, label: this.$t('notificationsList.Listing.eHost'), class: 'text-rigth' },
                { key: 'portNo', sortable: true, label: this.$t('notificationsList.Listing.ePort'), class: 'text-rigth'},
                { key: 'userId', sortable: true, label: this.$t('notificationsList.Listing.eUserID'), class: 'text-rigth'},
                { key: 'senderName', sortable: true, label: this.$t('notifications.eSenderName'), class: 'text-rigth'},
                { key: 'senderEmail', sortable: true, label: this.$t('notifications.eSenderEmail'), class: 'text-rigth'}
            ],
            pageOptions: [5, 10, 15],
            totalRows: 0,
            currentPage: 1,
            perPage: 10,
            filter: null,
            filterOn: [],
            items: [],
            selected: [],
            Header: {},
            isReadOnly: false,
            destination: [],
            dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr'
        };
    },

    computed: {
        sortOptions() {
            return this.fields
                .filter(f => f.sortable)
                .map(f => {
                    return { text: f.label, value: f.key };
                });
        }
    },

    methods: {
        formatPhone(value) {
            if (value && value.length >= 10) {
                var cleaned = ('' + value).replace(/\D/g, '');
                var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
                if (match) {
                    return '(' + match[1] + ')' + match[2] + '-' + match[3];
                }
            } else {
                return '';
            }
        },

        AddNotification() {
            this.Mode = 'Add';
            this.emitDataforFavorites();
            this.$router.push({ name: 'notifications-add' }).catch(() => {});
        },

        SearchNotification() {
            this.items = [];
            this.currentPage = 1;
            this.parameter.PageNumber = 1;
            this.totalRows = this.items.length;
            this.getNotificationListing();
        },

        editNotification(row) {
            this.code = row.recId;
            this.Mode = 'Edit';
            this.$router.push({ name: 'notifications-details', params: { id: this.code } });
        },

        removeNotification(row) {
            const Id = row.recId;
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
                    title: this.$tc('Shared.DelRecord'),
                    okTitle: this.$t('Shared.TitleDelete'),
                    cancelTitle: this.$t('Shared.BtnCancel'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning',
                    id: 'modal_delete_Notification'
                })
                .then(value => {
                    if (value) {
                        NotificationsService.Delete(Id)
                            .then(() => {
                                const index = this.items.findIndex(item => item.recId === Id); // find the post index
                                if (~index) {
                                    // if the post exists in array
                                    this.items.splice(index, 1); //delete the post and refresh view
                                    this.getNotificationListing(); //refresh listing
                                }
                            })
                            .catch(error => {
                                if (!error.response) {
                                    this.showMessage(
                                        this.$tc('Msg.Error'),
                                        this.$t('Msg.retrieveInfo'),
                                        'error'
                                    );
                                } else if (error.response.status === 400) {
                                    this.showMessage(
                                        this.$tc('Msg.Error'),
                                        error.response.data.errorMessage,
                                        'error'
                                    );
                                } else if (error.response.status === 500) {
                                    this.showMessage(
                                        this.$tc('Msg.Error'),
                                        this.$t('Msg.ThereWereSomeError'),
                                        'error'
                                    );
                                } else {
                                    this.showMessage(
                                        this.$tc('Msg.Error'),
                                        error.response.data.errorMessage,
                                        'error'
                                    );
                                }
                                this.showResponseErrorMessage(error);
                            });
                    }
                });
        },

        getNotificationListing() {
            this.parameter.PageNumber = this.currentPage;
            this.parameter.PageSize = this.perPage;
            NotificationsService.getAll(this.parameter)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.items = response.data;
                        let headerString = response.headers['x-pagination'];
                        this.totalRows = JSON.parse(headerString).TotalCount;
                    }
                })
                .catch(error => {
                    if (!error.response) {
                        this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.retrieveInfo'), "error");
                    }
                    else if (error.response.status === 400) {
                        this.showMessage(this.$tc('Msg.Error'), error.response.data.errorMessage, "error");
                    }
                    else if (error.response.status === 405) {
                        this.$router.push({ name: "Main" });
                        setTimeout(() =>
                            this.showPermissionMessage()
                            , 50);
                    }
                    else if (error.response.status === 500) {
                        this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.ThereWereSomeError'), "error");
                    } else {
                        this.showMessage(this.$tc('Msg.Error'), error.response.data.errorMessage, "error");
                    }
                    this.showResponseErrorMessage(error);
                });
        },

        pageChanged(page) {
            this.currentPage = page;
            this.getNotificationListing();
        },

        perPageFunction(perpage) {
            this.perPage = perpage;
            this.currentPage = 1;
            this.getNotificationListing();
        },

        onRowSelected(items) {
            this.selected = items;
        },

        selectAllRows() {
            this.$refs.selectableTable.selectAllRows();
        },

        clearSelected() {
            this.$refs.selectableTable.clearSelected();
        },

        selectThirdRow() {
            this.$refs.selectableTable.selectRow(2);
        },

        unselectThirdRow() {
            this.$refs.selectableTable.unselectRow(2);
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        }
    },

    mounted() {
        this.OptionsRightMenu.ItemsList = [];
        let layoutStatus = this.$store.state.layoutStatus;
        switch (layoutStatus) {
            case 'L0R1':
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            case 'L1R0':
            case 'L1R1':
                this.OptionsRightMenu.btnvisible = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            default:
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }
        this.getNotificationListing();
    }
};
</script>
